import React from "react";
import MuiInputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export const InputBase = withStyles((theme) => ({
  root: {
    padding: "10px 6px",
    background: "white",
    borderRadius: "8px",
    "& .MuiInputBase-input": {
      minWidth: 20,
    },
  },
  input: {
    padding: 0,
    "&:focus": {
      backgroundColor: "unset",
    },
  },
}))(MuiInputBase);

function Autocomplete(props) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <MuiAutocomplete
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      renderInput={(params) => (
        <InputBase
          ref={params.InputProps.ref}
          inputProps={params.inputProps}
          placeholder={props.placeholder}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={handleOpen}
                style={{ ...(open && { transform: "rotate(180deg)" }) }}
              >
                <ExpandMoreIcon
                  htmlColor="#6A7888"
                  style={{ fontSize: "1.425rem" }}
                />
              </IconButton>
            </InputAdornment>
          }
        />
      )}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    gap: 6,
    borderRadius: 8,
    border: "1px solid #DEE5EC",
    overflow: "hidden",
  },
  input: {
    paddingLeft: "12px",
  },
  divider: {
    backgroundColor: "#DEE5EC",
  },
}));

export function TextfieldWithSelect(props) {
  const classes = useStyles();
  const { InputProps = {}, AutocompleteProps = {} } = props;
  return (
    <Paper elevation={0} className={classes.root}>
      <InputBase className={classes.input} {...InputProps} />
      <Divider orientation="vertical" flexItem className={classes.divider} />
      <Autocomplete {...AutocompleteProps} />
    </Paper>
  );
}
